export default __webpack_public_path__ + "static/media/985.54a3e318.png";